const addOrderStyleToSections = () => {
  const mainContent = document.querySelector("#MainContent");
  const sectionsEdito = mainContent.querySelectorAll(".shopify-section.section--edito");
  for (let i = 0; i < sectionsEdito.length; i++) {
    sectionsEdito[i].style.order = i + 1;
    const editoSection = sectionsEdito[i].querySelector(".edito-section");
    if (editoSection) {
      const orderMobile = getComputedStyle(editoSection).getPropertyValue("--order-mobile");
      if (orderMobile) {
        sectionsEdito[i].style.setProperty("--order-mobile", orderMobile);
      } else {
        sectionsEdito[i].style.setProperty("--order-mobile", i + 1);
      }
    }
  }
};
document.addEventListener("DOMContentLoaded", () => {
  const html_document = document.documentElement;
  if (!html_document.classList.contains("shopify-design-mode")) {
    addOrderStyleToSections();
  }
});
